import { WizardContext } from '../WizardContext'
import { cloneElement, useState, useEffect } from 'react'

export const Wizard = ({ steps, onStepChange }) => {
    const [context, setContext] = useState({})
    const [currentStep, setCurrentStep] = useState(0)
    const [mergedSteps, setMergedSteps] = useState([])
    const totalSteps = steps.length

    useEffect(() => {
        const _merged = steps.map((stepObj) => {
            return cloneElement(stepObj.component, {
                [stepObj.stepFunc.name]: (data) => {
                    if ('execute' in stepObj.stepFunc) {
                        stepObj.stepFunc.execute(data)
                    }
                    updateWizardContext(data)
                    handleNext()
                },
            })
        })
        setMergedSteps(_merged)
    }, [])

    // Effect to trigger onComplete when the step reaches the end
    useEffect(() => {
        onStepChange(currentStep)
    }, [currentStep])

    const updateWizardContext = (data) => {
        setContext((prevData) => ({
            ...prevData,
            ...data,
        }))
    }

    const handleNext = () => {
        setCurrentStep((prevStep) => {
            return prevStep + 1
        })
    }

    return (
        <div>
            <WizardContext.Provider value={{ context }}>
                <div>{mergedSteps[currentStep]}</div>
            </WizardContext.Provider>
        </div>
    )
}
